var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/upload_button.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.to-array.js";
import React, { useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { IconButton } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  upload: {
    "id": "upload_button.label",
    "defaultMessage": "Add media attachment"
  }
});
const onlyImages = types => {
  return Boolean(types && types.every(type => type.startsWith('image/')));
};
const UploadButton = ({
  disabled = false,
  unavailable = false,
  onSelectFile,
  resetFileKey
}) => {
  const intl = useIntl();
  const fileElement = useRef(null);
  const attachmentTypes = useAppSelector(state => state.instance.configuration.getIn(['media_attachments', 'supported_mime_types']));
  const handleChange = e => {
    if (e.target.files?.length) {
      onSelectFile(e.target.files);
    }
  };
  const handleClick = () => {
    fileElement.current?.click();
  };
  if (unavailable) {
    return null;
  }
  const src = onlyImages(attachmentTypes) ? require('@tabler/icons/photo.svg') : require('@tabler/icons/paperclip.svg');
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    src: src,
    className: "text-gray-400 hover:text-gray-600",
    title: intl.formatMessage(messages.upload),
    disabled: disabled,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("label", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.upload)), /*#__PURE__*/React.createElement("input", {
    key: resetFileKey,
    ref: fileElement,
    type: "file",
    multiple: true,
    accept: attachmentTypes && attachmentTypes.toArray().join(','),
    onChange: handleChange,
    disabled: disabled,
    className: "hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 9
    }
  })));
};
export default UploadButton;